import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';
import type SearchConstituent from '@/types/api/SearchConstituent';

const connectionsColumn = {
  columnKey: ConstituentSearchColumn.NUM_CONNECTIONS,
  headerName: 'CONNECTIONS_LABEL',
  render: (constituent: SearchConstituent) =>
    constituent.numConnections ? constituent.numConnections : null,
};

export default connectionsColumn;
